function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { Crisp } from "crisp-sdk-web";
import React, { useEffect, useMemo, useState } from "react";
import { Outlet, ScrollRestoration, useLocation, useNavigation, useResolvedPath } from "react-router-dom";
import PropTypes from "prop-types";
import posthog from "posthog-js";
import { BuildingOffice2Icon, Cog6ToothIcon, UserGroupIcon, QuestionMarkCircleIcon, BuildingLibraryIcon, ComputerDesktopIcon, ServerStackIcon, TruckIcon, QueueListIcon, ShieldCheckIcon, ArchiveBoxIcon } from "@heroicons/react/24/outline";
// import { thunkOptions } from "../../../providers/reduxProvider";
import { configSelectors } from "../../../redux/config";
import { notificationType } from "../../notifications/NavbarNotifications";
import Sidebar from "../../uikit/Sidebar/Sidebar";
import SidebarContent from "../../uikit/Sidebar/SidebarContent";
import SidebarProvider from "../../uikit/Sidebar/SidebarProvider";
import SidebarBrand from "../../uikit/Sidebar/SidebarBrand";
import Logo from "../../../../resources/images/icons/LeftMenuLogo.svg";
import LogoDark from "../../../../resources/images/icons/LeftMenuLogoDark.svg";
import Trans from "../../intl/Trans";
import SidebarMenuItem from "../../uikit/Sidebar/SidebarMenuItem";
import SidebarMenuItemContent from "../../uikit/Sidebar/SidebarMenuItemContent";
import { useGoogleAnalyticsEvent } from "../GoogleTagManager";
import Navbar from "../Navbar";
import routes from "../../router/routes";
import SidebarMenuItemChildren from "../../uikit/Sidebar/SidebarMenuItemChildren";
import useDarkMode from "../../../hooks/useDarkMode";
import { useDispatch, useSelector } from "react-redux";
import useNavigate from "../../../vendor/router/useNavigate";
import { authActions, authSelectors } from "../../../redux/auth";
import { useApplicationLoaderContext } from "../ApplicationLoaderContext";
import useFlashMessenger from "../../../hooks/useFlashMessenger";
import { useLaravelEchoContext } from "../LaravelEchoContextProvider";
import { myCompaniesSelectors } from "../../../redux/myCompanies";
import { createListenersFactory, handlePusherNavbarNotifications } from "../utils";
import { btCodesActions, btCodesSelectors } from "../../../redux/btCodes";
import handleReportError from "../../errors/handleReportError";
import { USERS_READ } from "../../Authorization/permissions";
// import { useModalManagerContext } from "../ModalManagerContext";
// import { getErrorMessageTranslated, mapErrorByHttpStatusCode } from "../../../hooks/useErrorMessage";
// import { useTranslation } from "react-i18next";
PrivateLayout.propTypes = {
    children: PropTypes.node
};
function handleRevokedPermission(_) {
    return _handleRevokedPermission.apply(this, arguments);
}
function _handleRevokedPermission() {
    _handleRevokedPermission = _async_to_generator(function(param) {
        var dispatch, setIsPageLoaderShown, e;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    dispatch = param.dispatch, setIsPageLoaderShown = param.setIsPageLoaderShown;
                    setIsPageLoaderShown(true);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        Promise.all([
                            dispatch(authActions.getPermissions()),
                            dispatch(authActions.getSubscriptions())
                        ])
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    setIsPageLoaderShown(false);
                    handleReportError(e);
                    window.location.reload();
                    throw e;
                case 4:
                    setIsPageLoaderShown(false);
                    return [
                        2
                    ];
            }
        });
    });
    return _handleRevokedPermission.apply(this, arguments);
}
export default function PrivateLayout(param) {
    var _param_children = param.children, children = _param_children === void 0 ? null : _param_children;
    /**
     * --------------------
     * Enable darkMode or not
     * --------------------
     */ var darkMode = useDarkMode();
    var hasIdentity = useSelector(authSelectors.hasIdentity);
    var myCompanyId = useSelector(myCompaniesSelectors.selectedCompanyId);
    // const { t: translate } = useTranslation();
    // TODO: this on a deploy is not set somehow...
    // const { showModalAsync } = useModalManagerContext();
    // const { setErrorMessage } = useFlashMessenger();
    var crispWebsiteId = useSelector(configSelectors.crispWebsiteId);
    var _useState = _sliced_to_array(useState(false), 2), shouldHideSidebar = _useState[0], setShouldHideSidebar = _useState[1];
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var setIsPageLoaderShown = useApplicationLoaderContext().setIsPageLoaderShown;
    var hasUsersReadPermission = useSelector(authSelectors.hasPermission)(USERS_READ);
    useEffect(function() {
        setIsPageLoaderShown(false);
        return function() {
            return setIsPageLoaderShown(true);
        };
    }, []);
    var listen = useLaravelEchoContext().listen;
    useEffect(function() {
        // List of events
        var events = [
            notificationType.CLIENT_INVOICES_EFACTURA_REJECTED,
            notificationType.CLIENT_INVOICES_EFACTURA_MESSAGE_RECEIVED,
            notificationType.ETRANSPORT_DECLARATION_FAILED_TO_REGISTER,
            notificationType.ETRANSPORT_DECLARATION_FAILED_TO_SEND,
            notificationType.ETRANSPORT_VEHICLE_MODIFICATION_FAILED_TO_REGISTER,
            notificationType.ETRANSPORT_VEHICLE_MODIFICATION_FAILED_TO_SEND,
            notificationType.ETRANSPORT_CONFIRMATION_FAILED_TO_REGISTER,
            notificationType.ETRANSPORT_CONFIRMATION_FAILED_TO_SEND,
            notificationType.BILLING_SUBSCRIPTION_EXPIRED
        ];
        // Default callback
        var defaultCallback = function() {
            handlePusherNavbarNotifications({
                dispatch: dispatch,
                myCompanyId: myCompanyId
            });
        };
        // Custom callback for specific event
        var customCallbacks = _define_property({}, notificationType.BILLING_SUBSCRIPTION_EXPIRED, /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        handlePusherNavbarNotifications({
                            dispatch: dispatch,
                            myCompanyId: myCompanyId
                        });
                        // Additional logic for this specific event
                        return [
                            4,
                            handleRevokedPermission({
                                dispatch: dispatch,
                                setIsPageLoaderShown: setIsPageLoaderShown
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        }));
        // Use the factory to create listeners
        var cleanupListeners = createListenersFactory({
            listen: listen,
            events: events,
            defaultCallback: defaultCallback,
            customCallbacks: customCallbacks
        });
        // Cleanup all listeners on unmount
        return function() {
            cleanupListeners();
        };
    }, []);
    /**
     * ----
     * The sidebar menu
     * ----
     */ var sidebarElements = [
        {
            icon: /*#__PURE__*/ React.createElement(ComputerDesktopIcon, {
                className: "h-8 w-8"
            }),
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.dashboard"),
            to: routes.DASHBOARD,
            id: "dashboard"
        },
        {
            icon: /*#__PURE__*/ React.createElement(BuildingLibraryIcon, {
                className: "h-8 w-8"
            }),
            id: "my-companies",
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.my-companies"),
            to: routes.MY_COMPANIES
        },
        {
            icon: /*#__PURE__*/ React.createElement(BuildingOffice2Icon, {
                className: "h-8 w-8"
            }),
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.partners"),
            to: routes.PARTNERS,
            id: "partners"
        },
        {
            id: "products",
            icon: /*#__PURE__*/ React.createElement(ServerStackIcon, {
                className: "h-8 w-8"
            }),
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.products"),
            children: [
                {
                    id: "products.categories",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.products.categories"),
                    to: routes.PRODUCTS_CATEGORIES
                },
                {
                    id: "products.manage",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.products.manage"),
                    to: routes.PRODUCTS
                }
            ]
        },
        {
            id: "clients",
            icon: /*#__PURE__*/ React.createElement(UserGroupIcon, {
                className: "h-8 w-8"
            }),
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.clients"),
            "data-tutorial-id": "clients",
            children: [
                // {
                //     label: <Trans>layout.sidebar.clients.contracts</Trans>,
                //     to: routes.CLIENTS_CONTRACTS,
                // },
                // {
                //     label: <Trans>layout.sidebar.clients.offers</Trans>,
                //     to: routes.CLIENTS_OFFERS,
                // },
                // {
                //     label: <Trans>layout.sidebar.clients.orders</Trans>,
                //     to: routes.CLIENTS_ORDERS,
                // },
                // {
                //     label: <Trans>layout.sidebar.clients.despatches</Trans>,
                //     to: routes.CLIENTS_DESPATCHES,
                // },
                {
                    id: "clients.invoices",
                    "data-tutorial-id": "clients-invoices",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.clients.invoices"),
                    to: routes.CLIENTS_INVOICES
                },
                {
                    id: "clients.proformas",
                    "data-tutorial-id": "clients-proforma-invoices",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.clients.proforma-invoices"),
                    to: routes.CLIENTS_PROFORMAS_INVOICES
                },
                {
                    id: "clients.payments",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.clients.payments"),
                    to: routes.CLIENTS_PAYMENTS
                },
                {
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.clients.receipts"),
                    to: routes.CLIENTS_RECEIPTS
                },
                {
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.clients.reports"),
                    to: routes.CLIENTS_REPORTS
                }
            ]
        },
        {
            id: "suppliers",
            icon: /*#__PURE__*/ React.createElement(TruckIcon, {
                className: "h-8 w-8"
            }),
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.suppliers"),
            children: [
                // {
                //     label: <Trans>layout.sidebar.suppliers.contracts</Trans>,
                //     to: routes.SUPPLIERS_CONTRACTS,
                // },
                // {
                //     label: <Trans>layout.sidebar.suppliers.offers</Trans>,
                //     to: routes.SUPPLIERS_OFFERS,
                // },
                // {
                //     label: <Trans>layout.sidebar.suppliers.orders</Trans>,
                //     to: routes.SUPPLIERS_ORDERS,
                // },
                // {
                //     label: <Trans>layout.sidebar.suppliers.despatches</Trans>,
                //     to: routes.SUPPLIERS_DESPATCHES,
                // },
                {
                    id: "suppliers.invoices",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.suppliers.invoices"),
                    to: routes.SUPPLIERS_INVOICES
                },
                {
                    id: "suppliers.payments",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.suppliers.payments"),
                    to: routes.SUPPLIERS_PAYMENTS
                },
                {
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.suppliers.receipts"),
                    to: routes.SUPPLIERS_RECEIPTS
                },
                {
                    id: "suppliers.reports",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.suppliers.reports"),
                    to: routes.SUPPLIERS_REPORTS
                }
            ]
        },
        // {
        //     id: "store-management",
        //     icon: <ArchiveBoxIcon className="h-8 w-8" />,
        //     label: <Trans>layout.sidebar.store-management</Trans>,
        //     children: [
        //         {
        //             label: <Trans>layout.sidebar.store-management.goods-receipt-notes</Trans>,
        //             to: routes.STORE_MANAGEMENT_GOODS_RECEIPT_NOTES, // Nota Intrare Receptie
        //         },
        //         {
        //             label: <Trans>layout.sidebar.store-management.consumption-receipt-notes</Trans>,
        //             to: routes.STORE_MANAGEMENT_CONSUMPTION_RECEIPT_NOTES, // Bonuri de consum
        //         },
        //         {
        //             label: <Trans>layout.sidebar.store-management.transfer-receipt-notes</Trans>,
        //             to: routes.STORE_MANAGEMENT_TRANSFER_RECEIPT_NOTES, // Bonuri de Transfer
        //         },
        //         {
        //             label: <Trans>layout.sidebar.store-management.auto-receipt-notes</Trans>,
        //             to: routes.STORE_MANAGEMENT_AUTO_RECEIPT_NOTES, // Bonuri de autoreceptie
        //         },
        //         {
        //             label: <Trans>layout.sidebar.store-management.inventory</Trans>,
        //             to: routes.STORE_MANAGEMENT_INVENTORY,
        //         },
        //         {
        //             label: <Trans>layout.sidebar.store-management.reports</Trans>,
        //             to: routes.STORE_MANAGEMENT_REPORTS,
        //         },
        //     ],
        // },
        {
            id: "inventory",
            icon: /*#__PURE__*/ React.createElement(ArchiveBoxIcon, {
                className: "h-8 w-8"
            }),
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.inventory"),
            children: [
                {
                    id: "inventory.warehouses",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.inventory.warehouses"),
                    to: routes.INVENTORY_WAREHOUSES
                },
                {
                    id: "inventory.goods-receipt-notes",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.inventory.goods-receipt-notes"),
                    to: routes.INVENTORY_GOODS_RECEIPT_NOTES
                },
                {
                    id: "inventory.stock-reception-receipts",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.inventory.stock-reception-receipts"),
                    to: routes.INVENTORY_STOCK_RECEPTION_RECEIPT
                },
                {
                    id: "inventory.client-goods-despatch-advices",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.inventory.client-goods-despatch-advices"),
                    to: routes.INVENTORY_CLIENT_GOODS_DESPATCH_ADVICES
                },
                {
                    id: "inventory.stock-consumption-receipts",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.inventory.stock-consumption-receipts"),
                    to: routes.INVENTORY_STOCK_CONSUMPTION_RECEIPTS
                },
                {
                    id: "inventory.stocks-reports",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.inventory.stocks-reports"),
                    to: routes.INVENTORY_STOCKS_REPORTS
                }
            ]
        },
        {
            id: "spv",
            icon: /*#__PURE__*/ React.createElement(ShieldCheckIcon, {
                className: "h-8 w-8"
            }),
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.spv"),
            children: [
                {
                    id: "spv.efactura",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.spv.efactura"),
                    to: routes.SPV_EFACTURA
                },
                {
                    id: "spv.etransport",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.spv.etransport"),
                    to: routes.SPV_ETRANSPORT
                }
            ]
        },
        {
            id: "lists",
            icon: /*#__PURE__*/ React.createElement(QueueListIcon, {
                className: "h-8 w-8"
            }),
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.lists"),
            children: [
                {
                    id: "lists.banks",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.banks"),
                    to: routes.SETTINGS_BANKS
                },
                {
                    id: "settings.measurement-units",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.measurement-units"),
                    to: routes.SETTINGS_MEASUREMENT_UNITS
                },
                {
                    id: "settings.documents-series",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.documents-series"),
                    to: routes.SETTINGS_DOCUMENTS_SERIES
                },
                {
                    id: "settings.vat-rates",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.vat-rates"),
                    to: routes.SETTINGS_VAT_RATES
                }
            ]
        },
        {
            icon: /*#__PURE__*/ React.createElement(Cog6ToothIcon, {
                className: "h-8 w-8"
            }),
            id: "my-account",
            label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.my-account"),
            children: [
                {
                    id: "my-account.settings",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.my-account.settings"),
                    to: routes.MY_ACCOUNT
                },
                {
                    id: "my-account.exports",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.my-account.exports"),
                    to: routes.MY_ACCOUNT_EXPORTS
                }
            ].concat(_to_consumable_array(hasUsersReadPermission ? [
                {
                    id: "my-account.sub-users",
                    label: /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.sub-users-and-permissions"),
                    to: routes.MANAGEMENT_USERS
                }
            ] : []))
        }
    ];
    /**
     * --------------------
     * Calculate the active main sidebar element
     * --------------------
     */ var resolvedPath = useResolvedPath();
    var navigation = useNavigation();
    var active = useMemo(function() {
        var isActive = null;
        sidebarElements.forEach(function(item) {
            if (item.children) {
                item.children.forEach(function(child) {
                    if (resolvedPath.pathname.includes(child.to)) {
                        isActive = item.id;
                    }
                });
            }
        });
        return isActive;
    }, [
        resolvedPath.pathname
    ]);
    var _useFlashMessenger = useFlashMessenger(), opened = _useFlashMessenger.opened, setOpened = _useFlashMessenger.setOpened;
    var _useState1 = _sliced_to_array(useState(false), 2), hasNavigated = _useState1[0], setHasNavigated = _useState1[1];
    useEffect(function() {
        if (navigation.state === "idle" && opened) {
            setHasNavigated(true);
        }
        if (navigation.state === "loading" && hasNavigated) {
            setHasNavigated(false);
            setOpened(false);
        }
    }, [
        navigation.state
    ]);
    var gtmEvent = useGoogleAnalyticsEvent();
    /**
     * When the user is logged out (either from Navbar > Logout or from interceptor 401 situation)
     * redirect the user to the login page.
     */ useEffect(function() {
        if (!hasIdentity) {
            gtmEvent({
                eventName: "logout"
            });
            navigate(routes.AUTH_LOGIN);
        }
    }, [
        hasIdentity
    ]);
    var location = useLocation();
    var showEfacturaBtCodes = useSelector(btCodesSelectors.getShowEfacturaBtCodes);
    useEffect(function() {
        if (showEfacturaBtCodes) {
            return;
        }
        dispatch(btCodesActions.showEfacturaBtCodes(true));
    }, [
        location.pathname
    ]);
    useEffect(function() {
        posthog.capture("$pageview", {
            $current_url: window.location.href
        });
    }, [
        location
    ]);
    /**
     * When the user logs out we don't have any identity and the app can throw errors due to auth selectors.
     * This way we ensure that the app doesn't render anything while the user is redirected
     * to the login page.
     */ if (!hasIdentity) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SidebarProvider, {
        active: active
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex h-fit flex-row justify-stretch text-black"
    }, /*#__PURE__*/ React.createElement(Sidebar, {
        shouldHideSidebar: shouldHideSidebar,
        setShouldHideSidebar: setShouldHideSidebar
    }, /*#__PURE__*/ React.createElement(SidebarBrand, null, darkMode && /*#__PURE__*/ React.createElement(LogoDark, {
        className: "h-full max-h-24 w-full"
    }), !darkMode && /*#__PURE__*/ React.createElement(Logo, {
        className: "h-full max-h-24 w-full"
    })), /*#__PURE__*/ React.createElement(SidebarContent, null, sidebarElements.map(function(_param) {
        var label = _param.label, children = _param.children, item = _object_without_properties(_param, [
            "label",
            "children"
        ]);
        return /*#__PURE__*/ React.createElement(SidebarMenuItem, {
            key: item.id,
            id: item.id || item.to
        }, /*#__PURE__*/ React.createElement(SidebarMenuItemContent, _object_spread({
            end: item.to && item.to === routes.DASHBOARD
        }, item), label), children && /*#__PURE__*/ React.createElement(SidebarMenuItemChildren, null, children.map(function(_param) {
            var label = _param.label, child = _object_without_properties(_param, [
                "label"
            ]);
            return child.isButton ? /*#__PURE__*/ React.createElement(SidebarMenuItem, {
                key: child.key,
                id: child.key,
                className: "group"
            }, /*#__PURE__*/ React.createElement(SidebarMenuItemContent, {
                isChild: true,
                to: child.key,
                onClick: function(e) {
                    e.preventDefault();
                    child.onClick(e);
                }
            }, label)) : /*#__PURE__*/ React.createElement(SidebarMenuItem, {
                key: child.to,
                id: child.to,
                className: "group"
            }, /*#__PURE__*/ React.createElement(SidebarMenuItemContent, _object_spread_props(_object_spread({
                isChild: true
            }, child), {
                end: child.to === routes.DASHBOARD || resolvedPath.pathname === routes.MY_ACCOUNT_EXPORTS
            }), label));
        })));
    }), /*#__PURE__*/ React.createElement(SidebarMenuItem, {
        key: "help",
        id: "help"
    }, /*#__PURE__*/ React.createElement(SidebarMenuItemContent, {
        icon: /*#__PURE__*/ React.createElement(QuestionMarkCircleIcon, {
            className: "h-8 w-8"
        })
    }, /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.help-center")), /*#__PURE__*/ React.createElement(SidebarMenuItemChildren, null, /*#__PURE__*/ React.createElement(SidebarMenuItem, {
        key: "faq",
        id: "faq",
        className: "group"
    }, /*#__PURE__*/ React.createElement(SidebarMenuItemContent, {
        isChild: true,
        to: "https://help.robill.ro/ro",
        target: "_blank"
    }, /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.help-center.faq"))), /*#__PURE__*/ React.createElement(SidebarMenuItem, {
        key: "chat",
        id: "chat",
        className: "group"
    }, /*#__PURE__*/ React.createElement(SidebarMenuItemContent, {
        className: "mb-16",
        isChild: true,
        to: "chat",
        onClick: function(e) {
            e.preventDefault();
            setShouldHideSidebar(true);
            Crisp.chat.show();
            crispWebsiteId && Crisp.chat.open();
        }
    }, /*#__PURE__*/ React.createElement(Trans, null, "layout.sidebar.help-center.chat"))))))), /*#__PURE__*/ React.createElement("main", {
        className: "relative ml-0 flex max-w-full flex-grow flex-col text-black dark:bg-blue-900 dark:text-gray-200 pb-[85px]"
    }, /*#__PURE__*/ React.createElement(Navbar, null), children || /*#__PURE__*/ React.createElement(Outlet, null)))), /*#__PURE__*/ React.createElement(ScrollRestoration, null));
}
